import React, { useEffect } from 'react';
import './SuccessModal.css';

const SuccessModal = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="success-modal-overlay" onClick={onClose}>
      <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="success-icon-wrapper">
          <div className="success-icon-circle">
            <div className="checkmark-wrapper">
              <svg className="checkmark" viewBox="0 0 52 52">
                <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
              </svg>
            </div>
          </div>
        </div>
        
        <h2 className="success-title">✅ We got your message!</h2>
        <p className="success-message">
          {message || "We'll get back to you shortly."}
        </p>
        <p className="success-footer">
          Thank you for contacting <span className="company-name">Gentrobyte AI Labs</span>
          <br />
          <span className="company-tagline">— an AI-powered software development team.</span>
        </p>
        
        <div className="success-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
